import React, { useEffect, useRef, useState } from 'react';

interface ContextMenuProps {
  x: number;
  y: number;
  onClose: () => void;
  children: React.ReactNode;
}

const ContextMenu: React.FC<ContextMenuProps> = ({ x, y, onClose, children }) => {
  const menuRef = useRef<HTMLDivElement>(null);
  const [style, setStyle] = useState<React.CSSProperties>({
    position: 'fixed',
    top: `${y}px`,
    left: `${x}px`,
    zIndex: 1000,
    opacity: 0,
  });

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        onClose();
      }
    };
    setTimeout(() => {
        document.addEventListener('mousedown', handleClickOutside);
    }, 0);
    
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  useEffect(() => {
    if (menuRef.current) {
        const menuHeight = menuRef.current.offsetHeight;
        const menuWidth = menuRef.current.offsetWidth;
        const windowHeight = window.innerHeight;
        const windowWidth = window.innerWidth;

        let newTop = y;
        let newLeft = x;

        if (y + menuHeight > windowHeight) {
            newTop = y - menuHeight;
        }

        if (x + menuWidth > windowWidth) {
            newLeft = x - menuWidth;
        }

        if (newTop < 0) {
            newTop = 5;
        }
        if (newLeft < 0) {
            newLeft = 5;
        }

        setStyle({
            position: 'fixed',
            top: `${newTop}px`,
            left: `${newLeft}px`,
            zIndex: 1000,
            opacity: 1,
            transition: 'opacity 0.1s ease-in-out',
        });
    }
  }, [x, y]);

  return (
    <div ref={menuRef} style={style} className="bg-white dark:bg-gray-700 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none min-w-[160px]">
      <ul className="py-1">
        {children}
      </ul>
    </div>
  );
};

export const ContextMenuItem: React.FC<{ onClick?: () => void; children: React.ReactNode; disabled?: boolean }> = ({ onClick, children, disabled }) => {
    return (
        <li>
            <button
                onClick={onClick}
                disabled={disabled}
                className="w-full text-left block px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-brand-secondary hover:text-white disabled:text-gray-400 dark:disabled:text-gray-500 disabled:bg-transparent dark:disabled:bg-gray-700 disabled:cursor-not-allowed"
            >
                {children}
            </button>
        </li>
    );
}

export default ContextMenu;